'use client';

import Link from 'next/link';

import { Breadcrumb, BreadcrumbItem } from '@bytel/trilogy-react-ts';

export default function HomeBreadcrumb() {
    return (
        <Breadcrumb>
            <BreadcrumbItem routerLink={Link} href='/'>
                Accueil
            </BreadcrumbItem>
            <BreadcrumbItem routerLink={Link} href='/forfaits-mobiles/avec-engagement'>
                Forfaits mobiles
            </BreadcrumbItem>
            <BreadcrumbItem routerLink={Link} active>
                Forfaits sans engagement
            </BreadcrumbItem>
        </Breadcrumb>
    );
}
